export default __webpack_public_path__ + "f7e675892794b6b87f98469a1e6e7fc4.png";